module.exports = __webpack_public_path__ + "img/banner.1df8e653.png";